import { MMButton } from '@components'
import { _404 } from '@images'
import cn from '@integrations/classnames'
import { useNavigate } from '@integrations/routing'
import { paths } from 'mmfintech-backend-api'
import { tr } from 'mmfintech-commons'

import styles from './Error404View.module.scss'

function Error404View() {
  const navigate = useNavigate()

  return (
    <div className={cn(styles['error404-wrapper'], 'error404-wrapper')}>
      <div className={cn(styles['error404-container'], 'error404-container')}>
        <div className={cn(styles['error404-content'], 'error404-content')}>
          <img src={_404} alt='' />

          <div className={cn(styles['title'], 'title')}>{tr('FRONTEND.ERROR404.TITLE', 'Page not found.')}</div>
          <div className={cn(styles['subtitle'], 'subtitle')}>
            {tr('FRONTEND.ERROR404.SUBTITLE', 'Please, check the link.')}
          </div>

          <div className={cn(styles['buttons'], 'buttons')}>
            <MMButton
              type='button'
              caption={tr('FRONTEND.BUTTONS.BACK', 'Back')}
              onClick={() => navigate(paths.root())}
              data-test='back-button'
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Error404View
